export default {
  // 可能是通用的
  Chat_History: 'Chat History',
  History: 'History'
  // 独有
}
